<template>
<!-- Hey Parth ;) this Lobby is linked to the VeeamLive logo in the header... please continue edting the REG form with the actual Lobby page. I wanted to created one without the video flythrough. This one is /thelobby in the url, and the one with the REG form and video fly through is still /lobby in the url. That's all! -kat -->


  <div class="lobbynovideo">

    <template>
      <Header/>
      <HomeLobby />
    </template>

  </div>
  
</template>





<script>
import Header from "../components/Header.vue";
import HomeLobby from '../components/HomeLobby.vue';


export default {

  name: 'LobbyNoVideo',
  components: {
    Header,
    HomeLobby
  }

}

</script>
